export const CHARACTER_IMAGE_SHOW_EXTENSION: string[] = [
  "jpg",
  "jpeg",
  "JPG",
  "JPEG",
  "png",
];

export const CHARACTER_FILE_ROLE: { [key: string]: string } = {
  SIGN_IMAGE: "signImage",
};

export const CHARACTER_EDIT_RELATE = {
  RELATE_EDIT: "characterRelateEdit",
  RELATE_NAV: "characterRelateNav",
  EDIT_NAV: "characterEditNav",
  RELATE_ANSWER_ACTION_FORM_MODE: "relateAnswerActionFormMode",
  RELATE_EDIT_AUTO_SAVE: "characterRelateEditAutosave",
};
